export default __webpack_public_path__ + "static/media/img-0361-central-african-premium-face.130c7c06.png";